module.exports = __webpack_public_path__ + "static/15-10966ef1993e034abe982079713489f8.png";